import React from 'react';
import styled from 'styled-components';
import basicimg01 from '../../../images/basicimg01.png'
import basicimg02 from '../../../images/basicimg02.png'
import basicimg03 from '../../../images/basicimg03.png'
import checkbox_on from '../../../images/checkbox_on.png'
import checkbox_off from '../../../images/checkbox_off.png'
import arrow_icon from '../../../images/arrow_icon.png'




export default function MypagePfimgbasic({clearProfileImage,setProfileImg,setProfilecheck,updateNext,setShowModalTop}) {
    const ProfilecheckChange = (e) => { 
        setProfileImg("default_profile_" + e.target.value + ".png");
        setProfilecheck(e.target.value); 
        clearProfileImage();
    }
    return (
        <Pfinner> 
            <Top_inner style={{borderBottom:"solid calc(100vw*(1/375)) #d5d5d5"}}>
                <Back onClick={()=>{updateNext(-1); setProfilecheck(0)}}>
                    <img src={arrow_icon}></img>
                </Back>
                <Title>프로필 수정</Title>

                <Finish onClick={()=>{updateNext(-1);setShowModalTop(true)}}> 완료 </Finish>
            </Top_inner>

            <ProfileChangetit>기본 이미지 선택</ProfileChangetit>

            <CheckImageslist>

                <div>
                    <Basicinput type="radio" id="profile01" name="profile" value="3" onChange={ProfilecheckChange}></Basicinput>
                    <Basiclabel for="profile01">
                        <BasicImages><img src={basicimg02}></img></BasicImages>
                        <Basicheck></Basicheck>
                    </Basiclabel>
                </div>
                <div>
                    <Basicinput type="radio" id="profile02" name="profile" value="2" onChange={ProfilecheckChange}></Basicinput>
                    <Basiclabel for="profile02">
                        <BasicImages><img src={basicimg01}></img></BasicImages>
                        <Basicheck></Basicheck>
                    </Basiclabel>
                </div>
                <div>
                    <Basicinput type="radio" id="profile03" name="profile" value="1" onChange={ProfilecheckChange}></Basicinput>
                    <Basiclabel for="profile03">
                        <BasicImages><img src={basicimg03}></img></BasicImages>
                        <Basicheck></Basicheck>
                    </Basiclabel>
                </div>

            </CheckImageslist>


        </Pfinner>
    )
}

const Pfinner = styled.div`
    padding: calc(100vw*(17/375));
`

const ProfileChangetit = styled.h2`
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    letter-spacing: -0.38px;
    color: #4e4e4e;
    padding-bottom: calc(100vw*(18/375));
`
const CheckImageslist = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`
const BasicImages = styled.span`
    display:block;
    width:  calc(100vw*(103/375));
    height:  calc(100vw*(101/375));
    border: solid  calc(100vw*(1/375)) #c6c6c6;
    border-radius: 50%;
    overflow: hidden;
`
const Basicinput = styled.input`
    display:none;

    &:checked + label > em {
        background-image : url(${checkbox_on});
        background-repeat: no-repeat;
        background-size : calc(100vw*(29/375));
    }
    &:checked + label > span {
        border: solid  calc(100vw*(2/375)) #ffcf19;
    }
`
const Basiclabel = styled.label`
    position: relative;
`
const Basicheck = styled.em`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    display:block;
    width:  calc(100vw*(29/375));
    height:  calc(100vw*(29/375));
    background-image : url(${checkbox_off});
    background-repeat: no-repeat;
    background-size : calc(100vw*(29/375));.
`


const Top_inner = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 200;
    width: 100%;
    height: calc(100vw*(51/375));
    display: felx;
    align-items: center;
    padding:0 calc(100vw*(17/375));


`
const Title = styled.h1`
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    letter-spacing: 0.32px;
    // margin-left: calc(100vw*(131.2/375));
`

const Back = styled.a`
    display:block;
    width: calc(100vw*(9.8/375));
    height: calc(100vw*(16/375));
`
const Finish = styled.a`
    display:block;
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    line-height: 2.83;
    color: #ffc036;
    margin-left: calc(100vw*(-38/375));
`